import React from "react";

export default function Initials({ name = "", size = 40, className = "" }) {
  const letters = name.split(" ").map((p) => p[0]).join("").slice(0, 2).toUpperCase() || "U";
  return (
    <div
      className={`rounded-full bg-mabw-secondary text-white flex items-center justify-center font-semibold ${className}`}
      style={{ width: size, height: size, fontSize: size / 2.5, fontFamily: "Outfit" }}
    >
      {letters}
    </div>
  );
}
